import { CMI5 } from '../../const';
import { getLogger } from '../logger';

const debug = getLogger('services:cmi5:transformerService');

export let transformCMI5ToLibrary = (libraryCMI5 = {}) => {
  let library = [];

  libraryCMI5.forEach((bookCMI5, index) => {
    let course = bookCMI5.course;
    if (course && course.id && course.title && course.activityType === CMI5.ACTIVITY_TYPE.COURSE) {
      let book = transformCMI5ToContent(bookCMI5.course);
      book._id = bookCMI5._id && bookCMI5._id.$oid ? bookCMI5._id.$oid : null;

      book.key = index;
      book.description = course.description;
      book.activityId = course.id;
      book.image = course.imageUrl;
      book.previewImage = course.previewImageUrl;
      book.title = course.title;
      book.tags = course.tags;
      book.metadata = course.metadata;
      book.content = [];
      book.content = transformChildrenToUnitsAndLessons(bookCMI5.auOrBlock, book.content);

      library.push(book);
    } else {
      debug.error('The course format is wrong %O', bookCMI5);
    }
  });

  return library;
};

export let transformCMI5ToLibraryPaginator = (paginator = {}, links = {}, page = {}) => {
  if (links) {
    links.forEach(l => {
      paginator[l.rel] = l.href;
    });
  }
  paginator.total = page ? page.totalPages : 1;
  return paginator;
};

function transformChildrenToUnitsAndLessons(children, content) {
  if (children) {
    children.forEach((child, index) => {
      if (child && child.activityType) {
        if (child.activityType === CMI5.ACTIVITY_TYPE.UNIT || child.activityType === CMI5.ACTIVITY_TYPE.LESSON) {
          content.push(transformCMI5ToContent(child));
        }
      }
    });
  }
  return content;
}

function getId(cmi5) {
  let id;
  if (cmi5.componentId) {
    id = cmi5.componentId;
  } else if (cmi5.id) {
    id = cmi5.id;
  } else if (cmi5._id && cmi5._id.$oid) {
    id = cmi5._id.$oid;
  } else {
    id = Math.floor(Math.random() * 10 + 1);
  }

  return id;
}

function transformCMI5ToContent(cmi5) {
  let content = {};
  if (cmi5) {
    content._id = getId(cmi5);
    content.name = cmi5.title;
    content.activityId = cmi5.id;
    content.sectionId = null;
    content.imageUrl = cmi5.imageUrl;
    content.previewImageUrl = cmi5.previewImageUrl;
    content.activityType = cmi5.activityType;
    content.disabled = false;
    content.url = cmi5.url;
    content.content = [];
    if (cmi5.auOrBlock) content.content = transformChildrenToUnitsAndLessons(cmi5.auOrBlock, content.content);
  }
  return content;
}
